import { render, staticRenderFns } from "./AdminCards.vue?vue&type=template&id=0b84fd95&scoped=true"
import script from "./AdminCards.vue?vue&type=script&lang=js"
export * from "./AdminCards.vue?vue&type=script&lang=js"
import style0 from "./AdminCards.vue?vue&type=style&index=0&id=0b84fd95&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b84fd95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b84fd95')) {
      api.createRecord('0b84fd95', component.options)
    } else {
      api.reload('0b84fd95', component.options)
    }
    module.hot.accept("./AdminCards.vue?vue&type=template&id=0b84fd95&scoped=true", function () {
      api.rerender('0b84fd95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Topcards/AdminCards.vue"
export default component.exports